import { apiClient } from './apiClient';

class ClientAPI {
  getClients() {
    return apiClient.request(`/clients`, 'GET', true);
  }

  searchClients(params = {}) {
    return apiClient.request(`/clients/search`, 'POST', true, params);
  }

  getClient(id) {
    return apiClient.request(`/clients/${id}`, 'GET', true);
  }

  getClientServices(id, params = {}) {
    return apiClient.request(`/clients/${id}/services`, 'POST', true, params);
  }

  createClient(client) {
    return apiClient.request(`/clients`, 'POST', true, client);
  }

  updateClient(client) {
    return apiClient.request(`/clients/${client.id}`, 'PUT', true, client);
  }

  deleteClient(id, hard_delete = false, deactivate_reason) {
    return apiClient.request(`/clients/${id}`, 'DELETE', true, {
      hard_delete,
      deactivate_reason
    });
  }

  restoreClient(id) {
    return apiClient.request(`/clients/${id}/restore`, 'POST', true);
  }

  getClientPaymentProfile(id) {
    return apiClient.request(`/clients/${id}/payment_profile`, 'GET', true);
  }

  updateClientPaymentProfile(id, payment) {
    return apiClient.request(
      `/clients/${id}/payment_profile`,
      'PATCH',
      true,
      payment
    );
  }
}
export const clientAPI = new ClientAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/clientAPI.js